import { useEffect } from "react";

import { CONTACT_CHAT_SECTION_ROOT_ID } from ".";

export const useAutoScrollToBottom = () => {
	const targetEl = document.getElementById(CONTACT_CHAT_SECTION_ROOT_ID);

	useEffect(() => {
		if (!targetEl) {
			return;
		}

		targetEl.scroll(0, targetEl.scrollHeight - targetEl.clientHeight);
	}, [targetEl]);
};
